import { ORDER_APIS } from "@/api_framework/api_config";
import { IOrderManagementOrderListResponse, IOrderManagementSearchFilterBody } from "@/api_framework/api_modals/Orders";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setOrderList } from "@/app_redux/reducers/slices/auth/order_management_slice";
import axios from "axios";
import { useCallback } from "react";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useOrderManagementOrderListSearchAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterBody: IOrderManagementSearchFilterBody) => {
      dispatch(
        setLoading({
          key: "isQcOrderListLoadingInProgress",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response = await axios.post<IOrderManagementOrderListResponse>(
          ORDER_APIS?.ORDER_SEARCH_API?.baseURL ?? "",
          filterBody,
          {
            headers: {
              Authorization: accessToken ?? "",
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.status) {
          const searchList = Array.isArray(response.data.data) ? response.data.data : [];
          dispatch(
            setOrderList({
              data: searchList,
              totalOrders: searchList.length,
            }),
          );
        } else {
          dispatch(
            setOrderList({
              data: [],
              totalOrders: 0,
            }),
          );
        }
      } catch (error: any) {
        if (axios.isAxiosError(error)) {
          sendCurl(error.config?.["curlCommand"]);
        }

        dispatch(
          setOrderList({
            data: [],
            totalOrders: 0,
          }),
        );
      } finally {
        dispatch(
          setLoading({
            key: "isQcOrderListLoadingInProgress",
            status: false,
          }),
        );
      }
    },
    [dispatch, configuration],
  );

  return execute;
};
